// extracted by mini-css-extract-plugin
module.exports = {"firstRowWithControls":"khZ9Lh-uQK_RlYo_9ZmGy","secondRowWithControls":"_24aY33EYIQvi5Frrmy35gp","verticalAlignBlock":"_1XAs2QhAY9NqmJMPNnOpTT"};